export default "__VITE_ASSET__wv37s8mk__"